import apiClient from './apiClient';
import store from 'store';
import { LOGOUT_ACTION } from 'store/rootReducer';
import { extractApiErrorMessage } from './apiError';

/**
 * 서버 응답의 에러 메시지(msg)를 화면 상단에 팝업으로 표시한다.
 * 전역 토스트 인프라가 없어 body 에 직접 붙이는 경량 팝업으로 구현.
 * 클릭 시 즉시 닫히고, 그렇지 않으면 6초 후 자동 사라진다.
 */
const showErrorPopup = (message: string) => {
    const el = document.createElement('div');
    el.setAttribute('role', 'alert');
    el.textContent = message;
    Object.assign(el.style, {
        position: 'fixed',
        top: '16px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: '99999',
        maxWidth: '80vw',
        padding: '12px 16px',
        background: '#d32f2f',
        color: '#fff',
        borderRadius: '6px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        fontSize: '13px',
        lineHeight: '1.4',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        cursor: 'pointer'
    });
    el.addEventListener('click', () => el.remove());
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 6000);
};

export const setupInterceptors = () => {
    apiClient.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error.response?.status;
            if (status === 401) {
                store.dispatch({ type: LOGOUT_ACTION });
            }
            // Every 401 (the /userinfo auth probe, an /api/session check, or any call once the session
            // has expired) triggers LOGOUT_ACTION → redirect to /login, so a red popup on top is just
            // noise. Login is redirect-based (never sent via apiClient) and permission errors are 403,
            // so no 401 needs its own feedback. Other statuses can still opt out with { suppressErrorPopup: true }.
            if (!error.config?.suppressErrorPopup && status !== 401) {
                // The interceptor is the one caller that should surface transport-level info (HTTP status
                // or a network/timeout message) when the server sent no usable body — pass it as fallback.
                showErrorPopup(extractApiErrorMessage(error, status ? `Request failed (HTTP ${status})` : error.message || 'Request failed'));
            }
            return Promise.reject(error);
        }
    );
};
